import { Link } from 'foundations-components/transitional/components/Link';
import { HelpIcon } from 'foundations-components/transitional/components/HelpIcon';
import { Text } from 'foundations-components/components/Text';
import { getEmailEditConfigurationUrl } from '../../../urls/inboxSettingsUrls';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import { getFromName, getId, getFromEmail, getOriginalSenderName, getOriginalSenderEmail, getForwardedEmailContext, getConnectedAccountContext
// @ts-expect-error module not typed
} from 'conversations-message-history/context-update/operators/contextUpdateGetters';
import { IconCircle } from 'foundations-components/transitional/components/IconCircle';
import { InfoIcon } from 'foundations-assets';
// @ts-expect-error module not typed
import { getTimestamp } from 'conversations-message-history/common-message-format/operators/commonMessageFormatGetters';
import SystemMessage from 'conversations-inbox-message-history/system-message/SystemMessage';
import { jsx as _jsx } from "react/jsx-runtime";
const ForwardedEmailContextSystemUpdate = ({
  inboxId,
  message,
  ungatedForThreadMessagesUIImprovements
}) => {
  const forwardedEmailContext = getForwardedEmailContext(message);
  const from = getFromName(forwardedEmailContext) || getFromEmail(forwardedEmailContext);
  const originalSender = getOriginalSenderName(forwardedEmailContext) || getOriginalSenderEmail(forwardedEmailContext);
  const connectedAccountContext = getConnectedAccountContext(message);
  const emailId = getId(connectedAccountContext);
  if (forwardedEmailContext) {
    const connectedAccountLink = /*#__PURE__*/_jsx(Link, {
      href: getEmailEditConfigurationUrl({
        inboxId,
        emailId
      }),
      external: true,
      use: "blue",
      children: /*#__PURE__*/_jsx(FormattedReactMessage, {
        message: "conversations-thread-view.threadHistory.context-update-message.forwardedEmail.tooltip.tooltipLinkName"
      })
    });
    const tooltipMessage = /*#__PURE__*/_jsx(FormattedReactMessage, {
      message: "conversations-thread-view.threadHistory.context-update-message.forwardedEmail.tooltip.tooltipMessage",
      options: {
        inboxConfigurationLink: connectedAccountLink
      }
    });
    const forwardedEmailTooltip = /*#__PURE__*/_jsx(HelpIcon, {
      title: tooltipMessage,
      children: /*#__PURE__*/_jsx(Text, {
        as: "strong",
        color: "text-interactive-default",
        typography: "heading-50",
        children: originalSender
      })
    });
    return /*#__PURE__*/_jsx(SystemMessage, {
      timestamp: getTimestamp(message),
      description: /*#__PURE__*/_jsx(FormattedReactMessage, {
        message: "conversations-thread-view.threadHistory.context-update-message.forwardedEmail.forwardedEmailMessage",
        options: {
          originalSender,
          from,
          tooltip: forwardedEmailTooltip
        }
      }),
      icon: /*#__PURE__*/_jsx(IconCircle, {
        borderWidth: "0",
        icon: InfoIcon,
        size: "500"
      }),
      ungatedForThreadMessagesUIImprovements: ungatedForThreadMessagesUIImprovements
    });
  }
  return /*#__PURE__*/_jsx(SystemMessage, {
    timestamp: getTimestamp(message),
    description: /*#__PURE__*/_jsx(FormattedReactMessage, {
      message: "conversations-thread-view.threadHistory.context-update-message.unknownSourceMessage"
    }, 'chatflow-source-message'),
    icon: /*#__PURE__*/_jsx(IconCircle, {
      borderWidth: "0",
      icon: InfoIcon,
      size: "500"
    }),
    ungatedForThreadMessagesUIImprovements: ungatedForThreadMessagesUIImprovements
  });
};
ForwardedEmailContextSystemUpdate.displayName = 'ForwardedEmailContextSystemUpdate';
export default ForwardedEmailContextSystemUpdate;